export default {"src":"/_next/static/media/arrowBottom.82891e25.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};